export default "__VITE_ASSET__CYVu$pn___"